/* Use this component to extend specific search components */
import { Component, OnInit, Input, HostBinding, ChangeDetectionStrategy } from '@angular/core';

@Component({
    template: `<div>This component requires extending</div>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThumbsComponent {
    @Input() public loading: boolean = false;
    @Input() public src: string;
    @Input() public title: string;
    @Input() public width: number = 95;
    @Input() public height: number = 95;
    @Input() public bgColor: string = 'transparent';
    @Input() public isIcon: boolean = false;

    @HostBinding('class.is-loaded') public imgLoaded: boolean = false;

    public onLoaded($event: Event): void {
        this.imgLoaded = true;
    }
}
